import React, { useEffect, useState } from 'react';
import axios from 'axios';

const StockManagement = () => {
  const [products, setProducts] = useState([]);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState('');
  const [updatedStocks, setUpdatedStocks] = useState({}); // Store updated stock values

  // Fetch all products
  const fetchProducts = async () => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await axios.get('https://astrovidhya.in/api/products', {
        headers: { Authorization: `Bearer ${token}` },
      });
      setProducts(response.data);
    } catch (err) {
      console.error('Error fetching products:', err);
      setError('Failed to fetch products. Please try again.');
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  // Handle stock input change
  const handleStockChange = (id, value) => {
    setUpdatedStocks((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  // Handle stock update
  const handleStockUpdate = async (id) => {
    try {
      const token = localStorage.getItem('authToken');
      const newStock = updatedStocks[id];
      if (newStock === undefined) return; // No changes to update

      await axios.put(
        `https://astrovidhya.in/api/products/${id}/stock`,
        { stock: newStock },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setSuccessMessage('Stock updated successfully!');
      fetchProducts(); // Refresh the product list
      setTimeout(() => setSuccessMessage(''), 3000);
    } catch (err) {
      console.error('Error updating stock:', err);
      setError('Failed to update stock. Please try again.');
    }
  };

  return (
    <div className="stock-management bg-white p-6 rounded-lg shadow-md">
      <h1 className="text-2xl font-bold mb-4">Stock Management</h1>
      {error && <p className="text-red-500">{error}</p>}
      {successMessage && <p className="text-green-500">{successMessage}</p>}
      <table className="min-w-full border-collapse bg-white shadow-md rounded-lg overflow-hidden">
        <thead className="bg-gray-200">
          <tr>
            <th className="px-4 py-2 text-left font-medium text-gray-700">SKU</th>
            <th className="px-4 py-2 text-left font-medium text-gray-700">Name</th>
            <th className="px-4 py-2 text-left font-medium text-gray-700">Current Stock</th>
            <th className="px-4 py-2 text-left font-medium text-gray-700">Update Stock</th>
            <th className="px-4 py-2 text-left font-medium text-gray-700">Actions</th>
          </tr>
        </thead>
        <tbody>
          {products.map((product) => (
            <tr key={product._id} className="border-t border-gray-300">
              <td className="px-4 py-2">{product.sku}</td>
              <td className="px-4 py-2">{product.name}</td>
              <td className="px-4 py-2">{product.stock}</td>
              <td className="px-4 py-2">
                <input
                  type="number"
                  defaultValue={product.stock}
                  className="w-20 px-2 py-1 border rounded-md"
                  onChange={(e) => handleStockChange(product._id, e.target.value)}
                />
              </td>
              <td className="px-4 py-2">
                <button
                  className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
                  onClick={() => handleStockUpdate(product._id)}
                >
                  Save
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default StockManagement;
